import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { Router } from '@angular/router';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/@core/services/app/app.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-org-confirm-step',
  templateUrl: './org-confirm-step.component.html',
  styleUrls: ['./org-confirm-step.component.scss'],
})
export class OrgConfirmStepComponent implements OnInit, OnDestroy {
  constructor(
    private infraService: InfrastructureService,
    private readonly router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private appService: AppService,
    public darkModeService: DarkModeService
  ) { }

  @Input() organization: Organization;
  @Input() new: boolean;
  @Input() myForm;

  infra: Infrastructure;
  subscription: Subscription;
  
  ngOnInit() {
    this.subscription = this.infraService.currentInfra.subscribe(infra => {
      this.infra = infra;
    });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

  confirmNewOrg() {
    const loading = this.appService.openLoading();
    let ok: () => void;
    if (this.new) {
      this.infraService.refreshGlobalStatus();
      ok = () => {
        this.infraService.addOrganizationInfra(this.organization).subscribe((createdOrg) => {
          createdOrg ? this.closeOperation('ORG_ADMIN.ORG_CREATED', loading) : loading.close();
        });
      };
      this.translate.get(['ALERT.CONFIRM-TITLE', 'ALERT.CONFIRM-MESSAGE']).subscribe(values => {
        this.appService.openDialog(values['ALERT.CONFIRM-TITLE'], values['ALERT.CONFIRM-MESSAGE'], ok, () => { loading.close(); });
      });
    } else {
      ok = () => {
        this.infraService.updateOrganizationInfra(this.organization).subscribe((updatedOrg) => {
            if (updatedOrg) {
              this.closeOperation('ORG_ADMIN.ORG_UPDATED', loading);
            } else {
              loading.close();
            }
          });
      };
      this.translate.get(['ALERT.CONFIRM-TITLE', 'ALERT.CONFIRM-MESSAGE']).subscribe(values => {
        this.appService.openDialog(values['ALERT.CONFIRM-TITLE'], values['ALERT.CONFIRM-MESSAGE'], ok, () => { loading.close(); });
      });
    }
  }

  private closeOperation(title: string, loading) {
    const msg = this.translate.instant(title);
    this.snackBar.open(msg, null, { duration: 5000 });
    this.router.navigate(['/v1/status']);
    loading.close();
  }
}

